/*
 * @@Author: zhouwei
 * @Date: 2024-08-05 09:35:17
 * @Description:
 */

import React from 'react';
import PopTip from '_common/components/popTip/PopTip';

interface Pop {
  title: string | null;
  className: string;
  tips: any[];
}

interface DataSource {
  title: string;
  subTitle?: string | null;
  pop: Pop;
  titleTips?: string;
}

interface LeftTitleProps {
  dataSource: DataSource;
}

const LeftTitle: React.FC<LeftTitleProps> = ({
  dataSource = {
    title: '',
    subTitle: null,
    pop: {
      title: null,
      className: '',
      tips: [],
    },
  },
}) => {
  const { title, subTitle, pop, titleTips } = dataSource;
  const existPop = pop && pop.title && pop.title.length > 0;
  return (
    <div className={`input-title ${existPop ? 'input-tip-title' : ''}`}>
      {!existPop && title}
      {existPop && (
        <React.Fragment>
          <div className="pop-title">
            <span>{title}</span>
            <PopTip {...pop} />
          </div>
        </React.Fragment>
      )}
      {subTitle && <span className="sub-title">{subTitle}</span>}
      {titleTips && <div className="title-tips">{titleTips}</div>}
    </div>
  );
};

export default LeftTitle;
